module.exports = __webpack_public_path__ + "img/02.be3a343e.svg";